<template>
  <div class="accountFrom">
    <el-form
      :model="formData"
      :rules="ruleForm"
      ref="ruleForm"
      class="login-form"
    >
      <el-form-item ref="email" prop="email">
        <el-input
          v-model.trim="formData.email"
          placeholder="请输入用户名"
          size="large"
          autocomplete="true"
        >
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </el-form-item>
      <el-form-item ref="password" prop="password">
        <el-input
          v-model.trim="formData.password"
          :type="pwdInvisible ? 'password' : 'text'"
          placeholder="请输入登录密码"
          size="large"
          autocomplete="new-password"
        >
          <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          <i
            :style="`cursor: pointer;color:${pwdInvisible?'':'#4091ff'}`"
            slot="suffix"
            class="el-icon-view"
            @click="pwdInvisible = !pwdInvisible"
          ></i>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { debounce } from "lodash";
import * as loginApi from "@/util/api";
export default {
  data() {
    return {
      pwdInvisible: true,
      imageCode: "",
      formData: {
        email: "",
        password: "",
        code: "",
        verify: "",
      },
      ruleForm: {
        email: [
          { required: true, message: "用户名不能为空！", trigger: "blur" },
        ],
        password: [
          { required: true, message: "登录密码不能为空！", trigger: "blur" },
        ],
        code: [
          { required: true, message: "验证码不能为空！", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getImageVeryCodeHandler();
  },
  methods: {
    getImageVeryCodeHandler: debounce(function () {
      loginApi.getImageVeryCode().then((res) => {
        this.imageCode = res.data.barCode;
        this.formData.verify = res.data.verify;
      });
    }, 600),
  },
};
</script>

<style scoped lang="less">
.accountFrom {
  /deep/.login-form {
    .ant-form-explain {
      font-size: 12px;
    }
    .imageCodeItem {
      .ant-form-item-children {
        display: flex;
      }
      .ant-input {
        height: 36px;
      }
      .imageCode {
        width: 120px;
        height: 36px;
        border: 1px solid #d9d9d9;
        border-left: none;
        cursor: pointer;
        img {
          height: 32px;
        }
      }
      .changeImageCode {
        width: 100px;
        margin-left: 12px;
        cursor: pointer;
        user-select: none;
      }
    }
  }
}
</style>
